// Shared constants for the multi-step interest/registration form.

export const PROGRAMS = [
  { value: 'tackle', label: 'Tackle Football', ages: '7u-13u' },
  { value: 'flag', label: 'Flag Football', ages: '5-6' },
  { value: 'cheer', label: 'Cheerleading', ages: '5-14' },
  { value: 'spring_flag', label: 'Spring NFL FLAG', ages: '5-12' },
];

export const AGE_GROUPS = {
  tackle: ['7u', '8u', '9u', '10u', '11u', '12u', '13u'],
  flag: ['5-6'],
  cheer: ['5-7', '8-10', '11-14'],
  spring_flag: ['6u', '8u', '10u', '12u'],
};

export const TSHIRT_SIZES = ['YS', 'YM', 'YL', 'YXL', 'AS', 'AM', 'AL', 'AXL', 'A2XL'];

export const MYREC_URL =
  'https://libertyroadmd.myrec.com/info/activities/program_details.aspx?ProgramID=29897';
